import InfoOutlined from "@mui/icons-material/InfoOutlined";
import React, { useCallback } from "react";
import { Handle, Position } from "reactflow";
import { updateLocalStorage } from "../../../../AppDrawerNav";
import { Box, Tooltip, Typography } from "@mui/material";
import { HelpOutline } from "@mui/icons-material";
import GoldenResponseNode from "../GoldenResponseNode/GoldenResponseNode";
import ProblemStatementNode from "../ProblemStatementNode/ProblemStatementNode";
import {
  queryloopNodeStyles,
  topNavNode,
  topNavNodeText,
} from "../GeneralNodeStyles";
import theme from "../../../../../../Constants/theme";
function InputNodes({ data }) {
  const handleOpenSideBar = useCallback((infotype, event) => {
    event.stopPropagation(); // Prevent event from bubbling up to ReactFlow
    updateLocalStorage("open_sidebar", "true");
    updateLocalStorage("type", infotype);
  }, []);

  const { handleInputsTutorial } = data;

  return (
    <Box data-tour="step-one" sx={{ ...queryloopNodeStyles, width: "400px" }}>
      <Box sx={topNavNode}>
        <Typography sx={topNavNodeText}>Inputs</Typography>
        <Box>
          <Tooltip title="Click for more Information">
            <InfoOutlined
              onClick={(event) => handleOpenSideBar("input_nodes", event)}
              sx={{ mx: 1 }}
            />
          </Tooltip>
          <Tooltip title="Need Help?">
            <HelpOutline onClick={handleInputsTutorial} />
          </Tooltip>
        </Box>
      </Box>
      <Box>
        <Box sx={{ m: "20px" }}>
          <ProblemStatementNode data={data} />
        </Box>

        <Box sx={{ m: "20px" }}>
          <GoldenResponseNode data={data} />
        </Box>
      </Box>
      {/* connector point */}
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        style={{
          top: "2%",
          backgroundColor: theme.main.primaryBlue,
          height: "14px",
          width: "14px",
        }}
      />
    </Box>
  );
}

export default InputNodes;
